import { render } from "./TopResultsBox.vue?vue&type=template&id=7ac23cdc"
import script from "./TopResultsBox.vue?vue&type=script&lang=js"
export * from "./TopResultsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__